import { useSendToastMutation } from "../services/websocketApi.ts";

export function useToast() {
    const [sendToast] = useSendToastMutation();
    return (message: string, severity: string) => {
        sendToast({ topic: "toasts", author: "unknown", severity: severity, message: message });
    };
}
